import { Box, Grid, Tab as MuiTab, Tabs as MuiTabs } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useState } from 'react'

type TabPanelProps = {
  children?: React.ReactNode
  index: number
  value: number
}
const TabPanel = (props: TabPanelProps) => {
  const { children, value, index } = props

  return (
    <div
      style={{ height: '100%' }}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
    >
      {value === index && <Box sx={{ height: '100%' }}>{children}</Box>}
    </div>
  )
}

type Tab = {
  title: React.ReactNode
  content: React.ReactNode
  onChange?: () => void
}

interface TabsProps {
  tabs: Tab[]
  headerAppendage?: React.ReactNode
  defaultTabIndex?: number
}

export const Tabs = ({ tabs, headerAppendage, defaultTabIndex }: TabsProps) => {
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.down('sm'))
  const [currentTab, setCurrentTab] = useState(defaultTabIndex || 0)

  const handleTabChange = (_: React.ChangeEvent<unknown>, newValue: number) => {
    setCurrentTab(newValue)
    if (tabs[newValue] && tabs[newValue].onChange) {
      tabs[newValue].onChange()
    }
  }
  return (
    <Box sx={{ width: '100%', height: '100%', position: 'relative' }}>
      <Grid container>
        <Grid size={{ xs: 11, md: headerAppendage ? 11 : 12 }} sx={{ position: 'relative' }}>
          <MuiTabs
            value={currentTab}
            onChange={handleTabChange}
            scrollButtons
            allowScrollButtonsMobile
            variant={matches ? 'scrollable' : undefined}
          >
            {tabs.map((tab, index) => (
              <MuiTab label={tab.title} key={index} />
            ))}
          </MuiTabs>
        </Grid>
        {headerAppendage && (
          <Grid size={{ xs: 12, md: 1 }}>
            <Box sx={{ justifyContent: 'flex-end', display: 'flex' }}>{headerAppendage}</Box>
          </Grid>
        )}
      </Grid>
      {tabs.map((tab, index) => (
        <TabPanel value={currentTab} index={index} key={`${index}-content`}>
          {tab.content}
        </TabPanel>
      ))}
    </Box>
  )
}
